import React from 'react';
import classes from './Main.module.css';
import { Link } from 'react-router-dom';
import { servicesData } from '../../Assets/Data/ServicesData';
import Achievements from '../Achievements/Achievements';
// import { Donut } from "react-awesome-shapes/dist/shapes/donut";
import ScrollDown from '../UI/ScrollDownIndicator/ScrollDown';
import Header from '../UI/Header/Header';
import Canvas from '../Canvas/Canvas';

const Main = () => {
  return (
    <>
      <div className={classes['section-container']}>
        <Canvas />
        <section className={classes['section-top']}>
          <span className={classes.fname}>O</span>
          <span className={classes['fname-m']}>M</span>
        </section>
        <section className={classes['section-bottom']}>
          <div className={classes.content}>
            <Link to="/contact" className={classes.contact}>
              Contact
            </Link>
            {/* <span className={classes.lname}> */}
            <Header header="GAWANDE" styles={classes.lname} delay="2s" />
            {/* </span> */}

            <Link to="/about" className={classes.about}>
              About Me
            </Link>
          </div>
          <ScrollDown link="#services" />
        </section>
      </div>
      <section className={classes.services} id="services">
        <Header header="What I do?" styles={classes.heading} delay="2s" />
        <div className={classes.service_container}>
          {servicesData.map((s, i) => {
            return (
              <div key={i} className={classes.services}>
                <div className={classes.service}>
                  <img className={classes.image} src={s.imageSrc} alt="" />
                  <h1 className={classes.service_name}>{s.title}</h1>
                  <p className={classes.service_keyword}>{s.keyword}</p>
                </div>
              </div>
            );
          })}
        </div>
        <Link to="/projects" className={classes.service_btn}>
          View Projects
        </Link>
      </section>
      <section className={classes.achievements}>
        <Header header="Achievements" styles={classes.heading} delay="2s" />
        <Achievements />
      </section>
    </>
  );
};

export default Main;
